
<template>
  <div class="dropdown d-inline">
    <Button id="userStatusFilter" color="primary" variant="outline" :title="$t('key_userStatusFilter_title')" class="dropdown-toggle ms-2 " :class="statusSelected == '' ? '' : 'active-filter'"
      data-bs-toggle="dropdown" aria-expanded="false">
      <i class="fa-solid fa-user-large-slash" aria-hidden="true"></i>
    </Button>
    <ul class="dropdown-menu dropdown-menu-lg-start px-2 py-3" aria-labelledby="userStatusFilter">
      <li>
        <button class="dropdown-item border-radius-md text-enabled" type="button" @click="handleClick('ACTIVED')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-user me-3 text-enabled"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_userStatusFilter_user_enabled') }}</span>
        </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-userdisabled" type="button" @click="handleClick('NO_ACTIVED')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-user-slash me-3 text-userdisabled"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_userStatusFilter_user_disabled') }}</span>
        </button>
      </li>
      <li>
        <hr class="horizontal dark my-2" />
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-clearfilter" type="button" @click="handleClick('')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-eraser me-3 text-clearfilter"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_userStatusFilter_clear_filters') }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>

  import Button from "./../../../picko_components/generic_components/Button.vue";

  export default {
    name:"UserStatusFilter",
    components: {
      Button
    },
    props: {
      filterStatusSelected: {
        type: String,
        default: () => ''
      }
    },
    emits: ['filter-change'],
    data() {
      return {
        statusSelected: ''
      }
    },
    computed: {
      listFilters() {
        return this.$store.state.user.listFilters;
      }
    },
    watch: {
      filterStatusSelected() {
        this.statusSelected = this.filterStatusSelected;
      }
    },
    mounted() {
      this.setUpFilters();
    },
    methods: {
      handleClick(status) {
        this.statusSelected = status;
        this.$emit('filter-change', status);

        const dropdownElement = document.querySelector('.dropdown-menu.show');
        if (dropdownElement) {
          dropdownElement.classList.remove('show');
        }
      },
      setUpFilters() {
        if (Object.keys(this.listFilters).length > 0) {
          this.statusSelected = this.listFilters['status']
        }
      }
    }
  }

</script>

<style scoped>

  .active {
    background-color: rgb(234, 244, 247) !important;
  }

  .active-filter {
    color: #fff;
    background-color: #42695c;
    border-color: #42695c;
  }
  
</style>